var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464.323 204.902H405.995V146.575H487.55C459.722 87.7002 410.469 41.6668 349.85 17.8762C289.231 -5.91433 221.817 -5.66738 161.372 18.5642C100.928 42.7958 52.0132 89.1845 24.6145 148.261C-2.7842 207.337 -6.59982 274.643 13.947 336.438C34.4938 398.232 77.8534 449.852 135.172 480.76C192.491 511.667 259.445 519.53 322.364 502.743C385.284 485.955 439.423 445.785 473.726 390.432C508.03 335.079 519.912 268.718 506.945 204.902H464.323ZM366.005 376.177H307.076V245.638L169.638 383.077L127.389 340.828L262.776 205.42H137.77V146.492H366.005V376.177Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailArrow);
export default __webpack_public_path__ + "static/media/email_arrow.b5709aa6b1d75a7be5e1354af76157d0.svg";
export { ForwardRef as ReactComponent };